
import './Title.css'

const Title = () => {
    return (
        <div className='title'>
            <div className='title-container'>
                <h1 className='title-content'> Expense Tracker</h1>
            </div>
        </div>
    );
}

export default Title;